<template>
  <div>
    <header class="d-sm-flex justify-content-between align-items-center">
      <h1>Productos</h1>
      <b-button :to="{name: 'ProductNew'}" variant="outline-primary">Nuevo Producto</b-button>
    </header>
    <hr>
    <template v-if="isGetProductsLoading">
      <div class="text-center">
        <p class="lead">Loading...</p>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
    <template v-else>
      <template v-if="isProductsListEmpty">
        <p class="lead">De momento no hay clientes...</p>
      </template>
      <template v-else>
        <b-table
          striped
          borderless
          hover
          sort-by="createdAt"
          :sort-desc="true"
          :items="productsFormatted"
          :fields="tableFields"
          responsive="sm"
          @row-clicked="rowClicked"/>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin'

export default {
  name: 'Products',
  mixins: [dateMixin],
  created () {
    this.loadProducts()
  },
  data () {
    return {
      isGetProductsLoading: true,
      isProductsListEmpty: null,
      products: [],
      tableFields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'provenance',
          label: 'Origen',
          sortable: true
        },
        {
          key: 'quantity',
          label: 'Stock',
          sortable: true
        },
        {
          key: 'description',
          label: 'Descripción'
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        }
      ]
    }
  },
  computed: {
    productsFormatted () {
      return this.products.map(i => {
        i.createdAt = this.dateDDMMYYYY(i.createdAt)
        return i
      })
    }
  },
  methods: {
    ...mapActions([
      'getProducts'
    ]),
    loadProducts () {
      this.getProducts()
        .then((res) => {
          this.isGetProductsLoading = false
          if (res.empty) {
            this.isProductsListEmpty = true
            return false
          }
          res.forEach(doc => {
            this.products.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug('getProducts')
          console.log(err)
        })
    },
    rowClicked (item, index, ev) {
      this.$router.push({ name: 'ProductDetail', params: { productId: item.id } })
    }
  }
}
</script>
